<template>
    <v-dialog v-model="dialog" max-width="60%" transition="dialog-transition">
        <iframe :src="`/preview/index.html#/preview?id=${modelId}`" ref="iframe" width="100%" scrolling="no"
            style="min-height: calc(65vh)"></iframe>
    </v-dialog>
</template>

<script>
export default {
    props: {
        modelId: {
            type: String,
            default: ''
        },
        showDialog: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        dialog: {
            get() {
                return this.showDialog;
            },
            set(val) {
                this.$emit('update:showDialog', val)
            }
        }
    },
    data() {
        return {
            iframeWin: {},
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.iframeWin = this.$refs.iframe.contentWindow;
        })

    },
    methods: {
    }
}
</script>

<style>
.btn {
    width: 100px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    border: 1px solid #ccc;
    border-radius: 12px;
    position: fixed;
    top: 0;
    left: 0;
}

.iframeClass {
    width: 100%;
    height: 100vh;
}
</style>
